import HttpRequest from './http_request'

class EnglishProvider extends HttpRequest {
    constructor() {
        // api api
        super(process.env.VUE_APP_API_URL)
    }

    async getEnglishStudentInfo(student_id) {
        const { data } = await this.get('/', {
            function: 'get-english-student-info',
            student_id: student_id,
        })
        return data
    }

    async getExamType(student_id, level, inter, study) {
        const { data } = await this.get('/', {
            function: 'get-exam-type',
            student_id: student_id,
            level: level,
            inter: inter,
            study: study,
        })
        return data
    }

    async getEnglishScore(student_id, study, english_criteria_id) {
        const { data } = await this.get('/', {
            function: 'get-english-score',
            student_id: student_id,
            study: study,
            english_criteria_id: english_criteria_id,
        })
        return data
    }

    async getEnglishStudentList(year, semester, faculty_id) {
        const { data } = await this.get('/', {
            function: 'get-english-student-list',
            year: year,
            semester: semester,
            faculty_id: faculty_id,
        })
        return data
    }

    async getEnglishStudentSubmission(student_id, version_id) {
        const { data } = await this.get('/', {
            function: 'get-english-student-submission',
            student_id: student_id,
            version_id: version_id,
        })
        return data
    }

    async getGraduateStudentEnglishProof({ student_id, version_id, rand }) {
        const { data } = await this.get("/", {
            student_id: student_id,
            version_id: version_id,
            function: "get-graduate-student-english-proof",
            type: "file",
            rand: rand,
        }, {
            responseType: 'blob'
        });
        return data;
    }

    async createStudentEnglishSubmission(payload) {
        const formData = new FormData();
        formData.append("function", 'create-student-english-submission');
        formData.append("student_id", payload.student_id);
        formData.append("year", payload.year);
        formData.append("semester", payload.semester);
        formData.append("study", payload.study);
        formData.append("english_criteria_id", payload.english_criteria_id);
        formData.append("score", payload.score);
        formData.append("pass_date", payload.pass_date);
        formData.append("FILE[0]", payload.file);
        const { data } = await this.create('/', formData)
        return data
    }


    async saveStatusandComment(payload) {
        const { data } = await this.update('/', {
            function: 'save-status-and-comment',
            student_id: payload.student_id,
            version_id: payload.version_id,
            status_id: payload.status_id,
            approver_id: payload.approver_id,
            comment: payload.comment,
        })
        return data
    }

    async saveEnglishType(student_id, study, english_type_id, pass_date) {
        const { data } = await this.update('/', {
            function: 'save-english-type',
            student_id: student_id,
            study: study,
            english_type_id: english_type_id,
            pass_date: pass_date,
        })
        return data
    }
}

export default EnglishProvider
